var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    enableBackground: "new 0 0 15 15",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 15,
    height: 15,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAsVBMVEUsoCwsoCwsoCwsoCwq nyoqnyosoCwsoCwpnyksoCwtoS08pzxFq0UroCtYtFir2ava7trm9Oas2ax1wXXp9en////r9uv+ //7u9+7o9ei64LpWs1bG5cat2q30+vS537k9pz0+qD7F5cXc79zn9OfM6MxmumbL58u33rc7pztB qUG/4r81pDVNr02Uz5RCqkLB48Gs2qyq2ao2pDYonihEq0TD5MPq9eqk1qRRsVHq9ur+TBeqAAAA CnRSTlMAATSEucoRguSkZtiDhwAAAAFiS0dEFeXY+aMAAAAHdElNRQfmCxwKNCmV2WVEAAAAp0lE QVQI12WP6RKCMAyEAwULLS3liCje4H3jre//YLZ1xhnH/fclk90NAIDjEs/3iOuAVYsGjEecBbRl MRQyVolKpQj1wKEiy9GonQnqgBvIDxadrgxcICy1iGWvP2AEPK5wqHE0nlQ198CPprP5Aper9QaT yNf7utzu9vxwRFR6T1iDp/PletM3sb7X/nd8PCuNufE3+a/CROY23/Zr6m+/v/6//70BQOgN5CLc e2wAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMTEtMjhUMTA6NTI6MzcrMDA6MDCU47+AAAAAJXRF WHRkYXRlOm1vZGlmeQAyMDIyLTExLTI4VDEwOjUyOjM4KzAwOjAwE/Z31QAAACh0RVh0ZGF0ZTp0 aW1lc3RhbXAAMjAyMi0xMS0yOFQxMDo1Mjo0MCswMDowMH3JEXQAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.d3744b9614fdf9ecb893955582fa4e1e.svg";
export { ForwardRef as ReactComponent };